import { my_shop_data_methods } from "./my_shop_data_helper";
import { my_shop_product_methods } from "./my_shop_product_helper";

export const my_shop_helpers = {
    ...my_shop_data_methods,
    ...my_shop_product_methods,
};
